/**
 * Dia civil UTC (YYYY-MM-DD) ± N dias — LAC-142 setas no banner Envios SA.
 * Meio-dia UTC evita edge de DST ao só deslocar a data.
 */
export function shiftUtcDateIso(iso: string, deltaDays: number): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
    return iso;
  }
  const d = new Date(`${iso}T12:00:00.000Z`);
  if (Number.isNaN(d.getTime())) {
    return iso;
  }
  d.setUTCDate(d.getUTCDate() + deltaDays);
  return d.toISOString().slice(0, 10);
}
